import { getEditorWorker } from "./worker/workerManager";

// Entry point for the editor
export async function installEditor() {
  const { NWEditor } = await import("@/editor");
  getEditorWorker(true);
  return NWEditor;
}
